export default {"src":"/_next/static/media/EHACare-config-nut-icon.dd2cc37b.svg","height":72,"width":80};